import React from 'react';
import get from 'lodash/get';
import axios from '../utils/ajax';
import CMSComponent from '../components/CMSComponent';
import Page404 from './404';
import { DEFAULT_ZIPCODE } from '../constants/default';
import * as WEBSITES from '../constants/website';
import getHost from '../helpers/gethost';
import pageDisable from '../helpers/pageDisableHelper';
import { withConfig } from '../lib/withConfig';

const canonicalHref = `https://${getHost()}/new-ganja-goddess`;

function Contact({ html, error }) {
  if (error || process.env.NEXT_PUBLIC_APP !== WEBSITES.GANJAGODDESS) {
    return <Page404 showNavbar />;
  }
  return (
    <CMSComponent
      h1Title
      title={html?.title || "Welcome to the New Ganja Goddess"}
      metaDescription={
        'Ganja Goddess is the top weed delivery company in California. Reach us via Live Chat, or call us at (818) 949-1845.'
      }
      html={html}
      className="zipps-contact container"
      canonicalHref={canonicalHref}
    />
  );
}

async function getStaticPropsFunction() {
  if (process.env.NEXT_PUBLIC_CHECKOUT_ONLY === 'true' || process.env.NEXT_PUBLIC_APP !== WEBSITES.GANJAGODDESS) {
    return { props: {} };
  }

  try {
    const response = await axios({
      url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/cms/new-ganja-goddess`,
      method: 'GET',
      headers: { 'x-origin': process.env.HOST, zc: DEFAULT_ZIPCODE }
    });

    const responseData = get(response, 'data.data', {});
    let html = responseData.description;
    const first = html.indexOf('<script>') != -1 ? html.indexOf('<script>') + '<script>'.length : -1;
    const last = html.indexOf('</script>');
    const script = html.substring(first, last);
    html = html.replace('<script>', '');
    html = html.replace('</script>', '');
    html = html.replace(script, '');
    responseData.description = html;
    responseData.script = script;

    return {
      props: { html: responseData },
      revalidate: 10
    };
  } catch (error) {
    console.error('new-ganja-goddess', error);
    //remove this later
    return {
      props: {}
    }
    //remove this later
    throw error;
  }
}
export const getStaticProps = withConfig(getStaticPropsFunction)
export default pageDisable(Contact);
